module.exports = __webpack_public_path__ + "img/远志.3fda36cd.jpg";